import type { BillingPeriod, TierId } from '@gobingebox/shared';
import { apiFetch } from '@/lib/api';

export const billingApi = {
  config: () => apiFetch<{ enabled: boolean; publishableKey: string | null }>('/billing/config'),
  checkout: (tier: TierId, period: BillingPeriod, streams: number) =>
    apiFetch<{ clientSecret: string }>('/billing/checkout', {
      method: 'POST',
      body: JSON.stringify({ tier, period, streams }),
    }),
  portal: () => apiFetch<{ url: string }>('/billing/portal', { method: 'POST', body: JSON.stringify({}) }),
};
